import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import formStyles from 'pages/Form.module.css';
import { CreatePersonDocument } from 'graphql/mutations.generated';
import { useMutation } from '@apollo/client/react';
import globalStyles from 'Global.module.css';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [region, setRegion] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [createPerson, { loading }] = useMutation(CreatePersonDocument);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const result = await createPerson({
        variables: {
          email,
          password,
          username,
          region,
        },
      });
      
      if (result.data) {
        navigate('/');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    }
  };

  return (
    <div className={formStyles.formContainer}>
      <h1>Register</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="region">Region:</label>
            <input
            type="text"
            id="region"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            required
          />
        </div>
        {error && <div className={formStyles.error}>{error}</div>}
        <button type="submit" disabled={loading} className={globalStyles.submitButton}>
          {loading ? 'Creating account...' : 'Register'}
        </button>
      </form>
    </div>
  );
};

export default Register;

